// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout_layout__1Fn9t","fullscreen":"layout_fullscreen__3N0Oz","center":"layout_center__1G5_r","small":"layout_small__2iAuQ"};